export default "__VITE_ASSET__Bhptaztx__"